module.exports = __webpack_public_path__ + "img/1.551a8a73.png";